import {mount} from "svelte";
import SearchIcon from "./components/headerItems/SearchIcon.svelte";

mount(SearchIcon, {
  target: document.querySelector("#squirrel_searchIcon")!.parentElement as HTMLElement
})